<template>
    <table class="table table-style2 table-striped with-edit">
        <draggable v-model="arr"
                   :options="{draggable:'.item', handle:'.handle'}"
                   @end="reorder"
                   element="tbody"
        >
            <slot name="body" :arr="arr"></slot>
            <!-- Sample -->
            <!--<template slot="body" slot-scope="body">-->
                <!--<tr class="draggable item" v-for="element in body.arr" :key="element.id">-->
                    <!--<td v-html="$options.filters.nl2br(element.name)"></td>-->
                    <!--<td class="align-middle">-->
                        <!--<a href="#" class="handle btn-drag">-->
                            <!--<i class="fas fa-align-justify"></i>-->
                        <!--</a>-->
                    <!--</td>-->
                <!--</tr>-->
            <!--</template>-->
        </draggable>
    </table>
</template>

<script>
    import draggable from 'vuedraggable';

    export default {
        data() {
            return {
                arr: this.init_arr,
            }
        },
        props: {
            init_arr: {
                type: Array,
                required: true,
            }
        },
        methods: {
            reorder(e) {
                this.arr.forEach((item, index) => {
                    this.$set(this.arr[index], 'ordering', index + 1);
                });

				window.eventHub.$emit('reordered', this.arr);
            },
        },
        components: {
            draggable
        },
        watch: {
            init_arr() {
                this.arr = this.init_arr;
            }
        },
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/DragDropOrdering/DragDropOrdering.vue